import { between } from 'polished'
import styled from 'styled-components'

export const TitleWrapper = styled.h2`
  font-size: ${between('18px', '24px')};
  color: ${({ theme, color }) => theme.color[color]};
  line-height: 1.3;

  ${({ uppercase }) =>
    uppercase &&
    `
    text-transform:uppercase;
  `};

  ${({ semibold }) =>
    semibold &&
    `
    font-weight: 600;
  `};

  ${({ bold }) =>
    bold &&
    `
    font-weight: 700;
  `};

  ${({ marginTop }) =>
    marginTop &&
    `
      margin-top: ${marginTop}px;
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
      margin-bottom: ${marginBottom}px;
  `}

  ${({ marginLeft }) =>
    marginLeft &&
    `
      margin-left: ${marginLeft}px;
  `}

  ${({ marginRight }) =>
    marginRight &&
    `
      margin-right: ${marginRight}px;
  `}

  ${({ appearance }) =>
    appearance === 'bigger' &&
    `
    font-size: ${between('24px', '36px')};
    font-family: var(--adelle);
  `};

  ${({ appearance }) =>
    appearance === 'infobanner' &&
    `
    font-size: ${between('18px', '24px')};
    font-family: var(--adelle);
  `};
`
